import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useScript from 'react-script-hook';

const GenesysChat = (props) => {
  const {
    endpoint,
    product,
    source,
  } = props;

  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setShowChat(true);
      document.removeEventListener('scroll', handleScroll);
    }

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  });

  useScript({
    src: showChat ? `${source}/lib/cxbus.min.js` : null,
    checkForExisting: true,
    id: 'widgets',
    endpoint,
    product,
    async: true,
    onload: () => window.CXBus.loadFile(`${source}/widget_config.js`),
  });

  return null;
};

GenesysChat.propTypes = {
  endpoint: PropTypes.string,
  product: PropTypes.string,
  source: PropTypes.string,
};

export default GenesysChat;
